// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDqEfxr4VlnrQ4WDbaC2iX-3O3_UAZhC5U",
  authDomain: "longwefamily.firebaseapp.com",
  projectId: "longwefamily",
  storageBucket: "longwefamily.firebasestorage.app",
  messagingSenderId: "549916031925",
  appId: "1:549916031925:web:1140087bb087f7b57a37fc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);

export { app, db };